const BellIcon = props => (
  <svg
    {...props}
    width="54"
    height="54"
    viewBox="0 0 54 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 23C14 15.8203 19.8203 10 27 10C34.1797 10 40 15.8203 40 23V35H14V23Z"
      stroke="#00619E"
      strokeWidth="2"
    />
    <path
      d="M34 29C34 29.5523 34.4477 30 35 30C35.5523 30 36 29.5523 36 29H34ZM30.4118 15.0887C29.9086 14.8613 29.3162 15.0849 29.0887 15.5882C28.8613 16.0914 29.0849 16.6838 29.5882 16.9113L30.4118 15.0887ZM34 23.4747V29H36V23.4747H34ZM29.5882 16.9113C32.2259 18.1034 34 20.6143 34 23.4747H36C36 19.7486 33.69 16.5703 30.4118 15.0887L29.5882 16.9113Z"
      fill="#00AED9"
    />
    <path
      d="M30 10V8C30 6.34315 28.6569 5 27 5V5C25.3431 5 24 6.34315 24 8V10"
      stroke="#00619E"
      strokeWidth="2"
    />
    <path
      d="M24 45H30V46C30 47.6569 28.6569 49 27 49C25.3431 49 24 47.6569 24 46V45Z"
      stroke="#00619E"
      strokeWidth="2"
    />
    <path
      d="M44 41.0002H10L10 40.8058C10.0001 38.3678 11.3491 36.1369 13.4924 35.0005H40.5294C42.6585 36.1228 44 38.3352 44 40.7542V41.0002Z"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M39.3622 9.98869L40.5 3.5" stroke="#00AED9" strokeWidth="2" />
    <path
      d="M42.2185 13.2045L48.3117 9.03648"
      stroke="#00AED9"
      strokeWidth="2"
    />
    <path d="M43.636 17.0762L49.6571 18.383" stroke="#00AED9" strokeWidth="2" />
  </svg>
);

export default BellIcon;
